
import { defineComponent, onMounted } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "RedirectComponent",
  setup() {
    const route = useRoute();

    onMounted(() => {
      const currentPath = route.path;
      const query = route.query;
      const baseUrl = "https://jps-new.devtestapp.com";

      // 构建查询参数字符串
      const queryString =
        Object.keys(query).length > 0
          ? "?" +
            new URLSearchParams(query as Record<string, string>).toString()
          : "";

      let redirectUrl: string;

      // 检查是否是 /package/:path 路径
      if (currentPath.startsWith("/package/")) {
        // 保留原路径和查询参数
        redirectUrl = `${baseUrl}${currentPath}${queryString}`;
      } else if (currentPath.startsWith("/commit") && query.workflowId) {
        // 处理 /commit 路径，转换 workflowId 到路径参数
        const workflowId = query.workflowId;
        const otherParams = { ...query };
        delete otherParams.workflowId;

        const otherQueryString =
          Object.keys(otherParams).length > 0
            ? "?" +
              new URLSearchParams(
                otherParams as Record<string, string>
              ).toString()
            : "";

        redirectUrl = `${baseUrl}/commit/${workflowId}${otherQueryString}`;
      } else {
        // 其他路由直接跳转到根域名
        redirectUrl = `${baseUrl}/dashboard/project`;
      }

      // 执行重定向
      window.location.href = redirectUrl;
    });

    return {};
  },
});
